import React from "react";
import thankYouImage from "../assets/Thank-you.png";

const ThankYou = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100vw",
        backgroundColor: "#121122",
        padding: "20px",
        boxSizing: "border-box",
        flexDirection: "column", // Ensure stacking on mobile
      }}
    >
      <img
        src={thankYouImage}
        alt="Thank You for Signing Up"
        style={{
          maxWidth: "95vw", // Slightly smaller on mobile to avoid edge overflow
          maxHeight: "90vh", // Reduce height to fit mobile screens
          height: "auto",
          width: "auto",
          objectFit: "contain", // Maintain aspect ratio
        }}
      />
    </div>
  );
};

export default ThankYou;
